import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { DataSourceId } from "../../../globalTypes";
import {
  notificationsConnection,
  runSignalrAction,
} from "../../../requests/signalRConnections";
import { isFetching, isInitialLoadComplete } from "../../../utils/fetching";
import { store } from "../../configureStore";
import { useDismissNotfications } from "../useActions";
import * as AC from "./actionCreators";
import { getSystemNotificationsFetchStatus } from "./selectors";
import {
  useMappingNotificationIds,
  useSystemNotificationsFetchStatus,
} from "./useSelectors";

export const useResolveMappingNotifications = (dataSourceId: DataSourceId) => {
  const mappingNotificationIds = useMappingNotificationIds(dataSourceId);
  const dismissNotifications = useDismissNotfications();
  return () => {
    dismissNotifications(mappingNotificationIds);
  };
};

export const useFetchSystemNotificationsCB = () => {
  const dispatch = useDispatch();

  return () => {
    // Potřeba přes store.getState, přes useState nemám vždy aktuální data při multiple simultainious mountu useFetchSystemNotificationsCB
    const fetchStatus = getSystemNotificationsFetchStatus(store.getState());
    if (isFetching(fetchStatus)) return;
    dispatch(AC.requestSystemNotifications());
  };
};

export const useInitialSystemNotificationsFetch = () => {
  const fetchNotifications = useFetchSystemNotificationsCB();
  const fetchStatus = useSystemNotificationsFetchStatus();

  useEffect(() => {
    if (isInitialLoadComplete(fetchStatus)) return;
    runSignalrAction(notificationsConnection, fetchNotifications);
  }, []); // eslint-disable-line
};
